export default "__VITE_ASSET__CvKK_I3D__"